'use client'
import { useEffect } from 'react'

const SVG_TEMPLATE_ID = 'gradientProgressBar'
export const SVG_GRADIENT_ID = 'gradientProgressBarTemplate'
const setGradientForProgressBar = (percents: number) => {
  const dynamicY2 = percents < 10 ? 10 : percents
  const existedGradientTemplate = document.getElementById(SVG_TEMPLATE_ID)
  if (existedGradientTemplate) existedGradientTemplate.remove()
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  svg.setAttribute('id', SVG_TEMPLATE_ID)
  svg.setAttribute('style', 'position: absolute;top:0;width: 0;height:0')
  svg.innerHTML = `
 <defs>
    <linearGradient id=${SVG_GRADIENT_ID} x1="0%" y1="0%" x2=${
    dynamicY2 + '%'
  } y2=${dynamicY2 + '%'} gradientTransform="rotate(42)">
      <stop offset="0%"  style="stop-color: var(--progressBarGradientColor1)"/>
      <stop offset="80%" style="stop-color: var(--progressBarGradientColor2)"/>
    </linearGradient>
  </defs>
`

  document.body.appendChild(svg)
}

const useGradientForProgressBar = (percents: number) => {
  useEffect(() => {
    setGradientForProgressBar(percents)
  }, [percents])
}

export default useGradientForProgressBar
